import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { FIFTEEN_MINUTES, QUERY_KEYS } from '@avanta/shared/constants/common';
import { AppointmentService } from '../services/appointments';
import { type Speciality } from '../types/appointments';

export const useFetchSpecialities = (patientId: string): UseQueryResult<Speciality[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_SPECIALITIES, patientId],
    queryFn: () => AppointmentService.getSpecialities(patientId ?? ''),
    select: response => response.data,
    enabled: !!patientId,
    staleTime: FIFTEEN_MINUTES,
  });
